module.exports = __webpack_public_path__ + "media/10_6.91313d3c.wav";